import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { CustomFieldSummary } from '~/models/modules/customField';
import { CustomFieldsSummaryData } from '~/models/modules/customFieldData';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class CustomFieldsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.common);
    }

    getEntity(entity: string) {
        return this.http.get<number>(this._url(`/entity/${entity}`));
    }

    getCustomFieldsType() {
        return this.http.get<any>(this._url(`/fields-type`));
    }

    getCustomFieldById(id: number) {
        return this.http.get<CustomFieldSummary>(this._url(`/by-id/${id}`));
    }

    getFormTabsByPage(page: string) {
        return this.http.get<CustomFieldSummary>(this._url(`/customtab/${page}`));
    }

    getCustomFields(entity: string, page: string = null, entityId: string = null) {
        return this.http.get<CustomFieldSummary[]>(this._url(`/${entity}/${page}/${entityId}`));
    }

    getDeactivatedCustomFields(entity: string, page: string= null) {
      return this.http.get<CustomFieldSummary[]>(this._url(`/deactivatedFields/${entity}/${page}`));
    }
    getDeactivatedCustomForms(page: string= null) {
      return this.http.get<CustomFieldSummary[]>(this._url(`/deactivatedForms/${page}`));
    }

    getEntityData(paramsObj?: any, model?: any) {
        paramsObj = paramsObj || {};
        let params = createHttpParams(paramsObj);

        return this.http
            .post<CustomFieldsSummaryData[]>(this._url(`/entity-data`), model, {
                params,
                observe: 'response',
            })
            .pipe(map(augmentPaging));
    }

    createCustomField(model: any) {
        return this.client.post<string>(this._url(), model);
    }

    createCustomTab(model: any) {
        return this.client.post<string>(this._url(`/customtab`), model);
    }

    updateCustomField(id: number, model: any) {
        return this.client.put(this._url(`/${id}`), model);
    }

    updateCustomTab(id: number, model: any) {
        return this.client.put(this._url(`/customtab/${id}`), model);
    }

    deleteCustomField(id: number, model: any) {
        return this.client.put(this._url(`/deactivate/${id}`), model);
    }

    reactivateCustomField(id: number, model: any){
        return this.client.put(this._url(`/reactivate/${id}`), model);
    }
    reactivateFormTab(id: number, model: any){
      return this.client.put(this._url(`/customtab/reactivateFormTab/${id}`), model);
  }

    deleteCustomTab(id: number, model: any) {
        return this.client.put(this._url(`/customtab/deactivate/${id}`), model);
    }

    updateCustomFieldsReorder(model: any){
        return this.client.put(this._url(`/UpdateCustomFieldsOrder`), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/CustomFields${v}`);
    }
}
